// extracted by mini-css-extract-plugin
export default {"manage_btn":"Albums_manage_btn__9mzMs"};